import {
  GET_AUTH_INFO,
  GET_AUTH_INFO_ERROR,
  GET_AUTH_INFO_SUCCESS,
  GET_TOKEN,
  GET_TOKEN_ERROR,
  GET_TOKEN_SUCCESS
} from './AuthProvider.actions'

const initialState = {
  accessToken: '',
  business: '',
  dni: '',
  entCode: '',
  error: null,
  hasTokenError: false,
  isTokenLoading: true,
  loading: true,
  name: '',
  orgCode: '',
  roles: [],
  userType: '',
  usrCode: ''
}

/**
 * The AuthProvider reducer.
 */
export const authProviderReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AUTH_INFO: {
      return {
        ...state,
        error: null,
        loading: true
      }
    }
    case GET_AUTH_INFO_ERROR: {
      return {
        ...state,
        error: payload.error,
        loading: false
      }
    }
    case GET_AUTH_INFO_SUCCESS: {
      return {
        ...state,
        ...payload,
        error: null,
        loading: false
      }
    }

    case GET_TOKEN: {
      return {
        ...state,
        accessToken: '',
        hasTokenError: false,
        isTokenLoading: true
      }
    }
    case GET_TOKEN_ERROR: {
      return {
        ...state,
        hasTokenError: true,
        isTokenLoading: false
      }
    }
    case GET_TOKEN_SUCCESS: {
      return {
        ...state,
        accessToken: payload.accessToken,
        hasTokenError: false,
        isTokenLoading: false
      }
    }

    default: {
      return state
    }
  }
}
